import { ObjectValue } from 'src/app/reports/models/object-value.model';

export class FileOption extends ObjectValue {

  Icon: string;

  constructor(description: string, value: any, icon: string) {
      super(description, value);
      this.Icon = icon;
  }

}
